<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="rules-text" style="font-size:14px;">

            <p><a href="https://rules.promosis.com/share" target="_blank">Click here to view Official Rules</a></p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rules-text",
  data() {
    return {};
  },
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/app.scss";

.rules-text {
  &__program-name {
    text-align: center;
    font-size: 1.4rem;
    margin-bottom: 20px;
  }

  &__official-rules-line {
    text-align: center;
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rules/RulesText.vue